import { Navigate, useSearchParams } from 'react-router-dom';

import { PATH } from '../widget-lib/path-routes';

/**
 * Раньше отдельная страница фильтра; фильтры перенесены в модальное окно на `/schedule`.
 * Сохраняем маршрут для старых ссылок — редирект с сохранением query.
 */
export default function ScheduleFiltersPage() {
  const [searchParams] = useSearchParams();
  return <Navigate to={{ pathname: PATH.schedule, search: searchParams.toString() }} replace />;
}
